export default __webpack_public_path__ + "static/B0013-72964edd4ebc3def3edc2f7df78fcc8a.png";